/* Traveller Charms Set-Konfigurator (vanilla JS, keine Abhängigkeiten) */
(function () {
  'use strict';

  var REGIONS = [
    ['all', 'Alle'], ['eu', 'Europa'], ['as', 'Asien'], ['na', 'Nordamerika'],
    ['sa', 'Südamerika'], ['af', 'Afrika'], ['oc', 'Ozeanien']
  ];
  var PAGE = 36;
  var LANG = ((window.Shopify && window.Shopify.locale) || document.documentElement.lang || 'de').slice(0, 2).toLowerCase();
  if (/\.(de|at|ch)$/.test(location.hostname) && !/^\/(en|nl|it|fr|es)(\/|$)/.test(location.pathname)) LANG = 'de';
  function lbl(p) { return p[LANG] || (LANG === 'de' ? p.de : p.en) || p.en || p.de || ''; }
  var DICTS = {};
  function t(s) { var D = DICTS[LANG]; return D && D[s] !== undefined ? D[s] : s; }

  function eur(v) { return (Math.round(v * 100) / 100).toString().replace('.', ',') + ' €'; }
  function el(tag, cls, html) { var e = document.createElement(tag); if (cls) e.className = cls; if (html != null) e.innerHTML = html; return e; }
  function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function readJSON(root, sel) { try { return JSON.parse(root.querySelector(sel).textContent); } catch (e) { return null; } }

  function Builder(root) {
    this.root = root;
    this.cfg = readJSON(root, '[data-tcb-config]');
    this.variants = readJSON(root, '[data-tcb-variants]') || {};
    this.extras = readJSON(root, '[data-tcb-extras]') || {};
    this.images = readJSON(root, '[data-tcb-images]') || {};
    this.specials = readJSON(root, 'script[data-tcb-specials]') || [];
    this.shipThr = { keychain: +root.dataset.shipKeychain || 45, charms: +root.dataset.shipCharms || 25 };
    this.backCap = +root.dataset.backCap || 5;
    this.advent = root.dataset.mode === 'advent';
    this.fixed = +root.dataset.fixedCount || 24;
    var ob = root.querySelector('.tcb__open'); if (ob) ob.hidden = true;
    var wb = root.querySelector('[data-tcb-wrap]'); if (wb && wb.closest('.tcb__step')) wb.closest('.tcb__step').hidden = true;
    var sh = root.querySelector('.tcb__step-head .tcb__hint'); if (sh) sh.textContent = t('je 5 €, ohne Rückseitengravur');
    if (DICTS[LANG]) {
      var DICT = DICTS[LANG];
      root.querySelectorAll('.tcb__step-title, .tcb__choice, .tcb__choice strong, .tcb__choice small, .tcb__hint, .tcb__more, .tcb__btn-outline, .tcb__straps > span').forEach(function (n) {
        var raw = null; for (var i = n.childNodes.length - 1; i >= 0; i--) { if (n.childNodes[i].nodeType === 3 && n.childNodes[i].textContent.trim()) { raw = n.childNodes[i]; break; } } if (!raw) return;
        var v = raw.textContent.trim();
        if (/^Lederband:/.test(v)) { raw.textContent = ' ' + t('Lederband:') + ' '; return; }
        if (DICT[v] !== undefined) raw.textContent = (raw.textContent.charAt(0) === ' ' ? ' ' : '') + DICT[v];
      });
      var srch = root.querySelector('[data-tcb-search]'); if (srch) srch.placeholder = t('Land oder Stadt suchen');
      var nr = root.querySelector('[data-tcb-noresult]'); if (nr) nr.textContent = t('Nichts gefunden. Nimm einfach deinen eigenen Text, wir gravieren jeden Ort.');
    }
    this.state = {
      metal: root.dataset.defaultMetal || 'silber', keychain: true, strap: 'nude',
      picks: [], specials: [], open: 0, wrap: false, search: '', region: 'all', page: 1, seq: 1
    };
    this.data = { silver: [], gold: [] };
    this.$ = function (sel) { return root.querySelector(sel); };
    var ci = this.$('[data-tcb-custom]'); if (ci) { ci.maxLength = 12; ci.placeholder = t('Eigener Text, max. 12 Zeichen (+2 €)'); }
    this.bind();
    this.restore();
    this.renderStatic();
    this.load(root.dataset.charmData);
    this.render();
    var m = location.search.match(/[?&]edit=([^&]+)/);
    if (m) this.loadFromCart(decodeURIComponent(m[1]));
  }

  var P = Builder.prototype;

  /* Set aus dem Warenkorb zur Bearbeitung laden: Zeilen mit gleicher Set-Referenz entfernen, Zustand wiederherstellen */
  P.loadFromCart = function (ref) {
    var self = this;
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) {
      var lines = (cart.items || []).filter(function (it) { return it.properties && it.properties['_Set-Referenz'] === ref; });
      var main = lines.filter(function (it) { return it.handle === 'traveller-charms-set' || it.handle === 'adventskalender'; })[0];
      if (!main) return;
      var key = null; for (var k in self.variants) { if (self.variants[k].id === main.variant_id) { key = k; break; } }
      var st = { metal: 'silber', keychain: true, strap: 'nude', picks: [], specials: [], open: 0, wrap: false, search: '', region: 'all', page: 1, seq: 1 };
      if (key) { var parts = key.split('|'); st.metal = parts[0]; st.keychain = parts[1] !== 'nur charms'; }
      var strapLabel = main.properties['Lederband'];
      self.cfg.straps.forEach(function (s) { if (strapLabel && s.label === strapLabel) st.strap = s.id; });
      Object.keys(main.properties).sort().forEach(function (pk) {
        if (!/^(Charm|T\u00fcrchen) \d+$/.test(pk)) return;
        var v = String(main.properties[pk] || ''), segs = v.split(' | ').map(function (x) { return x.trim(); });
        var label = segs[0], back = '', custom = false, special = false;
        segs.slice(1).forEach(function (s) {
          if (s.indexOf('R\u00fcckseite: ') === 0) back = s.slice(11);
          else if (s === 'Eigener Text' || s === 'Symbol') custom = true;
          else if (s === 'Spezial') special = true;
        });
        if (special) { var sp = self.specials.filter(function (x) { return x.label === label; })[0]; if (sp) st.specials.push(sp.id); return; }
        st.picks.push({ uid: st.seq++, label: label, custom: custom, back: back });
      });
      var updates = {}; lines.forEach(function (it) { updates[it.key] = 0; });
      return fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ updates: updates }) })
        .then(function () {
          self.state = st; self.render();
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          try { history.replaceState(null, '', location.pathname); } catch (e) { }
          self.root.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
    }).catch(function (e) { if (window.console) console.warn('Set laden fehlgeschlagen', e); });
  };


  P.load = function (url) {
    var self = this;
    var extra = LANG !== 'de' && LANG !== 'en' ? fetch(url.replace('charm-data.json', 'charm-data-i18n.json')).then(function (r) { return r.json(); }).then(function (all) { return all[LANG] || {}; }).catch(function () { return {}; }) : Promise.resolve({});
    Promise.all([fetch(url).then(function (r) { return r.json(); }), extra]).then(function (res) {
      var d = res[0], names = res[1] || {};
      ['silver', 'gold'].forEach(function (k) { (d[k] || []).forEach(function (p) { if (names[p.en]) p[LANG] = names[p.en]; }); (d[k] || []).sort(function (a, b) { return lbl(a).localeCompare(lbl(b), LANG); }); });
      self.data = d; self.render();
    }).catch(function () { self.showError(t('Die Länderliste konnte nicht geladen werden. Bitte Seite neu laden.')); });
  };

  /* ---------- Preise ---------- */
  P.ladder = function () { return this.cfg.ladder[this.state.metal]; };
  P.band = function (k) { return k <= 1 ? 0 : k <= 5 ? 1 : k <= 10 ? 2 : 3; };
  P.cum = function (k) { var L = this.ladder(), s = 0; for (var i = 1; i <= k; i++) s += L[this.band(i)]; return s; };
  P.countAll = function () { return this.state.picks.length + this.state.open; };
  P.variantCount = function (n) { return this.advent ? this.fixed : Math.min(n, 20); };
  P.extraCharms = function (n) { return this.advent ? 0 : Math.max(0, n - 20); };
  P.calc = function () {
    var st = this.state, n = this.countAll();
    var backs = st.picks.filter(function (p) { return p.back && p.back.trim(); }).length;
    var customs = st.picks.filter(function (p) { return p.custom; }).length;
    var pack = backs >= this.backCap;
    var pkPrice = this.extras['ruckseiten-paket'] ? this.extras['ruckseiten-paket'].price / 100 : 9;
    var backCost = pack ? pkPrice : backs * this.cfg.backPrice;
    var vc = this.variantCount(n);
    var key = st.metal + '|' + (st.keychain ? 'mit schlüsselanhänger' : 'nur charms') + '|' + vc;
    var v = this.variants[key];
    var setPrice = v ? v.price / 100 : (st.keychain ? this.cfg.keychain[st.metal] : 0) + this.cum(vc);
    var xtra = this.extraCharms(n), xtraCost = xtra * (this.extras['zusatzlicher-charm'] ? this.extras['zusatzlicher-charm'].price / 100 : 2);
    var spPrice = this.extras['spezial-charm'] ? this.extras['spezial-charm'].price / 100 : 5;
    var extras = xtraCost + customs * this.cfg.customPrice + backCost + st.specials.length * spPrice;
    return { n: n, vc: vc, variant: v, setPrice: setPrice, backs: backs, pack: pack, customs: customs, xtra: xtra, total: setPrice + extras, snapExtra: 0, save: n * this.ladder()[0] - this.cum(n) };
  };

  /* ---------- Rendering ---------- */
  P.renderStatic = function () {
    var self = this;
    var straps = this.$('[data-tcb-straps]');
    straps.innerHTML = '';
    this.cfg.straps.forEach(function (s) {
      var b = el('button', 'tcb__strap', '<span style="--sw:' + s.hex + '"></span>');
      b.type = 'button'; b.dataset.strap = s.id; b.setAttribute('aria-label', 'Lederband ' + s.label);
      b.addEventListener('click', function () { self.set({ strap: s.id }); });
      straps.appendChild(b);
    });
    var regions = this.$('[data-tcb-regions]');
    REGIONS.forEach(function (r) {
      var b = el('button', 'tcb__region', t(r[1])); b.type = 'button'; b.dataset.region = r[0]; b.setAttribute('role', 'tab');
      b.addEventListener('click', function () { self.set({ region: r[0], page: 1 }); });
      regions.appendChild(b);
    });
    this.renderSpecials();
    this.initMini();
  };

  /* Mini-Vorschau (mobil): erscheint, sobald die große Vorschau aus dem Bild scrollt */
  P.initMini = function () {
    var self = this;
    if (this.mini) return;
    var m = el('button', 'tcb__mini', '<img class="tcb__mini-kc" alt="" data-mini-kc><div class="tcb__mini-discs" data-mini-discs></div><span class="tcb__mini-count" data-mini-count></span>');
    m.type = 'button'; m.hidden = true; m.setAttribute('aria-label', 'Zur Vorschau deines Sets springen');
    m.addEventListener('click', function () { self.$('.tcb__preview').scrollIntoView({ behavior: 'smooth', block: 'start' }); });
    this.root.appendChild(m); this.mini = m;
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (en) { self.miniVisible = !en[0].isIntersecting && window.innerWidth < 1000; self.updateMini(); }, { threshold: 0.05 });
      io.observe(this.$('.tcb__preview-inner'));
    }
  };
  P.updateMini = function () {
    var m = this.mini; if (!m) return;
    m.hidden = !this.miniVisible;
    if (m.hidden) return;
    var st = this.state, kc = this.$('[data-tcb-keychain]'), mk = m.querySelector('[data-mini-kc]');
    mk.hidden = kc.hidden; if (!kc.hidden) mk.src = kc.src;
    var discs = this.$('[data-tcb-discs]').innerHTML;
    var box = m.querySelector('[data-mini-discs]');
    if (box.innerHTML !== discs) { box.innerHTML = discs; m.classList.remove('is-pulse'); void m.offsetWidth; m.classList.add('is-pulse'); }
    m.querySelector('[data-mini-count]').textContent = this.$('[data-tcb-count]').textContent;
    box.scrollLeft = box.scrollWidth;
  };

  P.specialImage = function (s) { return (this.state.metal === 'gold' && s.image_gold) ? s.image_gold : (s.image || s.image_gold || ''); };

  P.renderSpecials = function () {
    var self = this;
    var sp = this.$('div[data-tcb-specials]');
    if (sp) {
      sp.innerHTML = '';
      [['kontinent', 'Kontinente'], ['symbol', 'Symbole und Wahrzeichen']].forEach(function (g) {
        var items = self.specials.filter(function (s) { return s.group === g[0]; });
        if (!items.length) return;
        sp.appendChild(el('span', 'tcb__specials-label', t(g[1])));
        var row = el('div', 'tcb__specials');
        items.forEach(function (s) {
          var im = self.specialImage(s);
          var b = el('button', 'tcb__special', (im ? '<img src="' + im + '" alt="" loading="lazy">' : '') + '<span>' + esc(s.label) + '</span>');
          b.type = 'button'; b.dataset.special = s.id; b.setAttribute('aria-pressed', 'false');
          b.addEventListener('click', function () {
            var arr = self.state.specials.slice(), i = arr.indexOf(s.id);
            if (i >= 0) arr.splice(i, 1); else arr.push(s.id);
            self.set({ specials: arr });
          });
          row.appendChild(b);
        });
        sp.appendChild(row);
      });
    }
  };

  P.render = function () {
    try { this.renderInner(); } catch (e) { this.showError('Konfigurator-Fehler: ' + (e && e.message ? e.message : e)); if (window.console) console.error(e); }
  };
  P.renderInner = function () {
    var self = this, st = this.state, c = this.calc(), L = this.ladder();
    /* Auswahlknöpfe */
    this.root.querySelectorAll('[data-tcb-metal]').forEach(function (b) { b.setAttribute('aria-pressed', String(b.dataset.tcbMetal === st.metal)); });
    this.root.querySelectorAll('[data-tcb-mode]').forEach(function (b) { b.setAttribute('aria-pressed', String((b.dataset.tcbMode === 'keychain') === st.keychain)); });
    this.$('[data-tcb-keychain-price]').textContent = t('Neu starten, +') + eur(this.cfg.keychain[st.metal]);
    this.root.querySelectorAll('[data-tcb-strap-row] .tcb__strap').forEach(function (b) { b.setAttribute('aria-pressed', String(b.dataset.strap === st.strap)); });
    this.$('[data-tcb-strap-row]').hidden = !st.keychain;
    var strap = this.cfg.straps.filter(function (s) { return s.id === st.strap; })[0];
    this.$('[data-tcb-strap-name]').textContent = t(strap.label);

    /* Preistreppe */
    var nextBand = this.band(c.n + 1);
    var bands = [[t('1. Charm'), eur(L[0])], [t('2. bis 5.'), t('je ') + eur(L[1])], [t('6. bis 10.'), t('je ') + eur(L[2])], [t('ab dem 11.'), t('je ') + eur(L[3])]];
    this.$('[data-tcb-bands]').innerHTML = bands.map(function (b, i) {
      return '<div class="tcb__band' + (i === nextBand ? ' tcb__band--active' : '') + '"><span>' + b[0] + '</span><strong>' + b[1] + '</strong></div>';
    }).join('');

    /* Regionen */
    this.root.querySelectorAll('.tcb__region').forEach(function (b) { b.setAttribute('aria-selected', String(b.dataset.region === st.region)); });

    /* Orte */
    var list = this.data.silver || [];
    var q = st.search.trim().toLowerCase();
    var filtered = list.filter(function (p) { return (st.region === 'all' || p.r === st.region) && (!q || lbl(p).toLowerCase().indexOf(q) >= 0 || (p.en || '').toLowerCase().indexOf(q) >= 0); });
    var shown = q ? filtered : filtered.slice(0, PAGE * st.page);
    var counts = {};
    st.picks.forEach(function (p) { if (!p.custom) counts[p.label] = (counts[p.label] || 0) + 1; });
    this.$('[data-tcb-places]').innerHTML = shown.map(function (p) {
      var L1 = lbl(p), n = counts[L1] || 0;
      return '<div class="tcb__place' + (n ? ' tcb__place--on' : '') + '"><button type="button" data-place="' + esc(L1) + '">' + esc(L1) + '</button>' + (n ? '<span class="tcb__place-count">' + n + '</span>' : '') + '</div>';
    }).join('');
    this.$('[data-tcb-noresult]').hidden = filtered.length > 0 || !list.length;
    this.$('[data-tcb-more]').hidden = !!q || shown.length >= filtered.length;

    /* Picks */
    var sec = this.$('[data-tcb-picks-section]');
    sec.hidden = st.picks.length === 0;
    var year = String(new Date().getFullYear());
    this.$('[data-tcb-back-note]').textContent = this.backNote(c);
    this.$('[data-tcb-picks]').innerHTML = st.picks.map(function (p) {
      return '<div class="tcb__pick" data-uid="' + p.uid + '"><span class="tcb__pick-label">' + esc(p.label) + (p.custom ? ' <small>' + t('(eigener Text)') + '</small>' : '') + '</span>' +
        '<input type="text" maxlength="12" placeholder="' + t('Rückseite') + '" value="' + esc(p.back || '') + '" aria-label="Rückseite für ' + esc(p.label) + '" data-back>' +
        '<button type="button" class="tcb__pick-year" data-year aria-label="' + year + ' auf die Rückseite">' + year + '</button>' +
        '<button type="button" class="tcb__pick-remove" data-remove aria-label="' + esc(p.label) + ' entfernen"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"><path d="M6 6l12 12M18 6L6 18"></path></svg></button></div>';
    }).join('');

    /* Spezial, Geschenk */
    this.root.querySelectorAll('.tcb__special').forEach(function (b) { b.setAttribute('aria-pressed', String(st.specials.indexOf(b.dataset.special) >= 0)); });
    this.$('[data-tcb-wrap]').setAttribute('aria-pressed', String(st.wrap));
    this.$('[data-tcb-open-count]').textContent = st.open;
    this.$('.tcb__open').classList.toggle('tcb__open--on', st.open > 0);

    /* Vorschau */
    var kc = this.$('[data-tcb-keychain]');
    var img = (this.images[st.metal] || {})[st.strap] || '';
    kc.hidden = !st.keychain || !img; if (img) kc.src = img;
    this.$('.tcb__stage').classList.toggle('tcb__stage--charms', !st.keychain || !img);
    var charmImg = (this.images.charm || {})[st.metal] || '';
    var discs = [];
    var maxVis = 12;
    st.picks.forEach(function (p) { discs.push({ t: 'text', label: p.label }); });
    for (var i = 0; i < st.open; i++) discs.push({ t: 'text', label: t('Offen') });
    st.specials.forEach(function (id) { var s = self.specials.filter(function (x) { return x.id === id; })[0]; if (s) { var si = self.specialImage(s); discs.push(si ? { t: 'img', src: si } : { t: 'text', label: s.label }); } });
    var goal = this.advent ? this.fixed : ([3, 5, 10].filter(function (g) { return g > discs.length; })[0] || 0);
    if (this.advent) maxVis = this.fixed;
    var html = '';
    var vis = discs.length > maxVis ? discs.slice(0, maxVis - 1) : discs;
    vis.forEach(function (d) {
      if (d.t === 'img') html += '<div class="tcb__disc tcb__disc--img"><img src="' + d.src + '" alt=""></div>';
      else html += '<div class="tcb__disc tcb__disc--' + st.metal + '"' + (charmImg ? ' style="background-image:url(' + charmImg + ')"' : ' style="background:' + (st.metal === 'gold' ? '#e2c170' : '#d0d3d6') + '"') + '><span>' + esc(d.label) + '</span></div>';
    });
    if (discs.length > maxVis) html += '<div class="tcb__disc tcb__disc--more">+' + (discs.length - maxVis + 1) + '</div>';
    else for (var j = discs.length; j < goal; j++) html += '<div class="tcb__disc tcb__disc--empty">' + (self.advent ? (j + 1) : '+') + '</div>';
    this.$('[data-tcb-discs]').innerHTML = html;

    var name = (st.keychain ? t('Schlüsselanhänger ') + t(strap.label) + ' + ' : '') + c.n + ' ' + (c.n === 1 ? t('Charm') : t('Charms')) + t(' in ') + (st.metal === 'gold' ? t('Gold') : t('Silber'));
    this.$('[data-tcb-caption]').textContent = name;
    var nAll = c.n + st.specials.length;
    var countLabel = this.advent ? nAll + ' / ' + this.fixed + ' ' + t('Türchen') : (nAll === 0 ? t('Noch leer') : nAll + ' ' + (nAll === 1 ? t('Charm') : t('Charms')));
    this.$('[data-tcb-count]').textContent = countLabel;
    this.$('[data-tcb-count-2]').textContent = countLabel;

    /* Leiste */
    var nudge;
    if (c.n === 0) nudge = '<strong>' + t('Erster Charm ') + eur(L[0]) + '.</strong> ' + t('Jeder weitere ab ') + eur(L[1]) + t(', später nur ') + eur(L[3]) + '.';
    else {
      var np = L[nextBand];
      nudge = '<strong>' + t('Dein nächster Charm kostet nur ') + eur(np) + '.</strong> ' + (nextBand < 3 ? t('Ab dem ') + [1, 2, 6, 11][nextBand + 1] + t('. Charm sogar nur ') + eur(L[nextBand + 1]) + '.' : t('Günstiger geht es nicht mehr.'));
      if (c.n > 40) nudge = '<strong>' + t('Maximal 40 Charms pro Set.') + '</strong>' + t(' Bitte ein paar entfernen oder ein zweites Set anlegen.');
    }
    if (this.advent && LANG !== 'de') { nudge = '<strong>' + nAll + ' / ' + this.fixed + ' ' + t('Türchen') + '</strong>'; }
    else if (this.advent) { var left = this.fixed - nAll; nudge = left > 0 ? '<strong>' + nAll + ' von ' + this.fixed + ' Türchen gefüllt.</strong> Noch ' + left + (left === 1 ? ' Reiseziel' : ' Reiseziele') + ' wählen, die Reihenfolge ist die Türchen-Reihenfolge.' : (left === 0 ? '<strong>Alle 24 Türchen gefüllt.</strong> Dein Kalender ist bereit.' : '<strong>Zu viele Reiseziele.</strong> Bitte ' + (-left) + ' entfernen, der Kalender hat ' + this.fixed + ' Türchen.'); }
    this.$('[data-tcb-nudge]').innerHTML = nudge;
    var thr = st.keychain ? this.shipThr.keychain : this.shipThr.charms;
    var rest = thr - c.total;
    this.$('[data-tcb-ship]').textContent = rest > 0 ? t('Noch ') + eur(rest) + t(' bis versandkostenfrei') : t('Versandkostenfrei');
    this.$('[data-tcb-save]').textContent = c.save > 0 ? t('Du sparst ') + eur(c.save) : '';
    this.$('[data-tcb-ship-fill]').style.width = Math.min(100, Math.round(c.total / thr * 100)) + '%';
    this.$('[data-tcb-total]').textContent = eur(c.total);
    var cta = this.$('[data-tcb-cta]');
    var ready = this.advent ? (nAll === this.fixed && c.variant && c.variant.available) : ((c.n >= 1 || st.keychain) && c.n <= 40 && c.variant && c.variant.available);
    cta.disabled = !ready;
    cta.textContent = this.advent ? (nAll === this.fixed ? t('Adventskalender in den Warenkorb') : (LANG === 'de' ? 'Noch ' + (this.fixed - nAll) + ' Türchen füllen' : LANG === 'en' ? (this.fixed - nAll) + ' doors left to fill' : t('Noch ') + (this.fixed - nAll) + ' ' + t('Türchen'))) : c.n === 0 ? (st.keychain ? (st.specials.length ? t('Anhänger + Spezial Charm in den Warenkorb') : t('Nur Anhänger in den Warenkorb')) : (st.specials.length ? t('Wähle dazu mindestens ein Reiseziel') : t('Wähle dein erstes Reiseziel'))) : (c.variant && !c.variant.available ? t('Diese Größe ist gerade nicht verfügbar') : t('In den Warenkorb'));
    this.updateMini();
    this.persist();
  };

  /* ---------- Events ---------- */
  P.bind = function () {
    var self = this, root = this.root;
    root.addEventListener('click', function (e) {
      var t = e.target.closest('button'); if (!t) return;
      if (t.dataset.tcbMetal !== undefined) { self.state.metal = t.dataset.tcbMetal; self.state.page = 1; self.renderSpecials(); return self.render(); }
      if (t.dataset.tcbMode !== undefined) return self.set({ keychain: t.dataset.tcbMode === 'keychain' });
      if (t.dataset.place !== undefined) return self.addPick(t.dataset.place, false);
      if (t.hasAttribute('data-tcb-more')) return self.set({ page: self.state.page + 1 });
      if (t.hasAttribute('data-tcb-custom-add')) {
        var inp = self.$('[data-tcb-custom]'), v = inp.value.trim(); if (!v) return inp.focus();
        self.addPick(v, true); inp.value = ''; return;
      }
      if (t.hasAttribute('data-tcb-open-plus')) return self.set({ open: self.state.open + 1 });
      if (t.hasAttribute('data-tcb-open-minus')) return self.set({ open: Math.max(0, self.state.open - 1) });
      if (t.hasAttribute('data-tcb-cta')) return self.addToCart();
      var row = t.closest('.tcb__pick');
      if (row) {
        var uid = +row.dataset.uid;
        if (t.hasAttribute('data-remove')) return self.set({ picks: self.state.picks.filter(function (p) { return p.uid !== uid; }) });
        if (t.hasAttribute('data-year')) return self.setBack(uid, String(new Date().getFullYear()));
      }
    });
    root.addEventListener('input', function (e) {
      var t = e.target;
      if (t.hasAttribute('data-tcb-search')) { self.state.search = t.value; self.state.page = 1; self.renderSoon(); }
      if (t.hasAttribute('data-back')) { var uid = +t.closest('.tcb__pick').dataset.uid; self.setBack(uid, t.value, true); }
    });
    root.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' && e.target.hasAttribute('data-tcb-custom')) { e.preventDefault(); self.$('[data-tcb-custom-add]').click(); }
    });
  };

  P.backNote = function (c) { var pk = eur(this.extras['ruckseiten-paket'] ? this.extras['ruckseiten-paket'].price / 100 : 9); return c.pack ? t('Rückseiten-Paket aktiv: alle Rückseiten zusammen nur ') + pk + '.' : t('Rückseite gravieren, z. B. Reisejahr oder Name: +') + eur(this.cfg.backPrice) + t(' pro Charm, ab ') + this.backCap + t(' Stück alle zusammen nur ') + pk + '.'; };
  P.renderSoon = function () { var self = this; clearTimeout(this._t); this._t = setTimeout(function () { self.render(); }, 80); };
  P.set = function (patch) { for (var k in patch) this.state[k] = patch[k]; this.render(); };
  P.addPick = function (label, custom) {
    var uid = this.state.seq++;
    this.state.picks.push({ uid: uid, label: label, custom: !!custom, back: '' });
    this.render();
  };
  P.setBack = function (uid, value, silent) {
    this.state.picks.forEach(function (p) { if (p.uid === uid) p.back = value; });
    if (silent) { this.updateTotalsOnly(); } else this.render();
  };
  P.updateTotalsOnly = function () {
    var c = this.calc(); this.$('[data-tcb-total]').textContent = eur(c.total); this.persist();
    this.$('[data-tcb-back-note]').textContent = this.backNote(c);
  };

  /* ---------- Speichern ---------- */
  P.persist = function () { try { localStorage.setItem(this.advent ? 'tcb-advent' : 'tcb-state', JSON.stringify(this.state)); } catch (e) { } };
  P.restore = function () {
    try {
      var s = JSON.parse(localStorage.getItem(this.advent ? 'tcb-advent' : 'tcb-state'));
      if (s && s.picks) { for (var k in s) if (k !== 'search' && k !== 'page' && k !== 'open' && k !== 'wrap') this.state[k] = s[k]; }
    } catch (e) { }
  };

  /* ---------- Warenkorb ---------- */
  P.showError = function (msg) { var e = this.$('[data-tcb-error]'); e.textContent = msg; e.hidden = false; };
  P.addToCart = function () {
    var self = this, st = this.state, c = this.calc();
    if (!c.variant) return this.showError(t('Für diese Kombination gibt es gerade keine Variante. Bitte Anzahl ändern.'));
    var strap = this.cfg.straps.filter(function (s) { return s.id === st.strap; })[0];
    var props = { 'Anzahl gewählt': String(c.n) };
    var idx = 0;
    function pad(n) { return (n < 10 ? '0' : '') + n; }
    function isSymbol(s) { return /^[^A-Za-z0-9\u00C0-\u024F\s.,'&()\/-]+$/.test(s); }
    st.picks.forEach(function (p) {
      var v = p.label;
      if (p.back && p.back.trim()) v += ' | Rückseite: ' + p.back.trim();
      if (isSymbol(p.label)) v += ' | Symbol';
      else if (p.custom) v += ' | Eigener Text';
      props[(self.advent ? 'Türchen ' : 'Charm ') + pad(++idx)] = v;
    });
    st.specials.forEach(function (id) { var s = self.specials.filter(function (x) { return x.id === id; })[0]; if (s) props[(self.advent ? 'Türchen ' : 'Charm ') + pad(++idx)] = s.label + ' | Spezial'; });
    props['Charms'] = st.picks.map(function (p) { return p.label; }).join(', ');
    if (st.keychain) props['Lederband'] = strap.label;
    var backs = st.picks.filter(function (p) { return p.back && p.back.trim(); }).map(function (p) { return p.label + ': ' + p.back.trim(); });
    if (backs.length) props['Rückseiten'] = backs.join(', ');
    var customs = st.picks.filter(function (p) { return p.custom; }).map(function (p) { return p.label; });
    if (customs.length) props['Eigener Text'] = customs.join(', ');
    var specials = st.specials.map(function (id) { var s = self.specials.filter(function (x) { return x.id === id; })[0]; return s ? s.label : ''; }).filter(Boolean);
    if (specials.length) props['Spezial Charms'] = specials.join(', ');
    var ref = 'TC-' + Date.now().toString(36).toUpperCase();
    props['_Set-Referenz'] = ref;

    var items = [{ id: c.variant.id, quantity: 1, properties: props }];
    var ex = this.extras;
    function add(key, qty, p) { if (ex[key] && qty > 0) items.push({ id: ex[key].id, quantity: qty, properties: Object.assign({ '_Set-Referenz': ref }, p || {}) }); }
    add('eigener-text', customs.length, { 'Für': customs.join(', ') });
    if (c.pack) add('ruckseiten-paket', 1, { 'Für': backs.join(', ') }); else add('ruckseite-graviert', c.backs, { 'Für': backs.join(', ') });
    add('spezial-charm', st.specials.length, { 'Für': specials.join(', ') });
    add('zusatzlicher-charm', c.xtra, { 'Für': 'Charms 21 bis ' + c.n });

    var cta = this.$('[data-tcb-cta]'); cta.classList.add('is-loading'); cta.textContent = t('Wird hinzugefügt…');
    this.$('[data-tcb-error]').hidden = true;
    fetch(this.cfg.cartAddUrl + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items }) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'Fehler'); return j; }); })
      .then(function () {
        try { localStorage.removeItem(self.advent ? 'tcb-advent' : 'tcb-state'); } catch (e) { }
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        window.location.href = self.root.dataset.afterAdd === 'checkout' ? '/checkout' : self.cfg.cartUrl;
      })
      .catch(function (err) {
        cta.classList.remove('is-loading'); cta.textContent = t('In den Warenkorb');
        self.showError(t('Das hat nicht geklappt: ') + err.message);
      });
  };

  function init() { document.querySelectorAll('[data-tcb]').forEach(function (r) { if (!r._tcb) r._tcb = new Builder(r); }); }
  function boot() {
    if (LANG === 'de') return init();
    var root = document.querySelector('[data-tcb]');
    if (!root) return;
    var url = root.dataset.charmData.replace('charm-data.json', 'charm-i18n.json');
    fetch(url).then(function (r) { return r.json(); }).then(function (d) { DICTS = d || {}; }).catch(function () { }).then(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', init);
})();
